module.exports = __webpack_public_path__ + "img/price-3290.a870d027.png";